export const styles = {
  stepper: {
    "& .MuiStepConnector-root": {
      marginLeft: "12px",
    },
    "& .MuiStepConnector-line": {
      minHeight: "1px",
      borderLeftWidth: "1px",
    },
  },
  stepContent: {
    py: 0.1,
    px: 0.1,
  },
  resultContainer: {
    mt: 0.1,
    p: 0.1,
    backgroundColor: "grey.100",
    borderRadius: 1,
  },
  errorMessage: {
    mt: 0.1,
    color: "#ff0000",
  },
};
